import { Drawer, IconButton } from '@/shared/ui';
import { readValue, valueText } from '../model/records';
import { findColumn, type AnalyticsObject } from '../model/schema';
import { RecordFieldList } from './RecordFields';

interface RecordDrawerProps {
  object: AnalyticsObject;
  /** The row to show, or null when closed. */
  row: object | null;
  onClose: () => void;
}

/** `dialog.drawer`: every field of a row of a table without record pages. */
export function RecordDrawer({ object, row, onClose }: RecordDrawerProps) {
  // The key columns name the row, e.g. "app-1 · 2026-03-01T10:00:00".
  const key = row
    ? object.defaultSortColumns
        .flatMap((name) => findColumn(object, name) ?? [])
        .map((column) => valueText(readValue(row, column)))
        .filter(Boolean)
        .join(' · ')
    : '';

  return (
    <Drawer
      open={row !== null}
      onClose={onClose}
      labelledBy="record-drawer-name"
      id="record-drawer"
    >
      {row && (
        <>
          <header className="drawer__head">
            <div className="drawer__titles">
              <span className="overline">{object.title}</span>
              <h2 className="drawer__name record-drawer__name" id="record-drawer-name">
                {key || 'Record'}
              </h2>
              <p className="drawer__tags">
                <span>
                  {object.schema}.{object.name}
                </span>
              </p>
            </div>
            <IconButton label="Close" icon="close" round onClick={onClose} />
          </header>
          <div className="drawer__body">
            <RecordFieldList object={object} record={row} />
          </div>
        </>
      )}
    </Drawer>
  );
}
